import React, { FC } from 'react';

interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width = 2155, height = 854 }) => {
	return (
		<img
			src='/OPEN-TALENTS-LOGO.svg'
			alt='OpenTalents'
			width={width}
			height={height}
			style={{ maxWidth: '100%', height: 'auto' }}
		/>
	);
};

export default Logo;
